import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import './TotalProduct.css';
export default function TotalProduct({ requestProduct }) {
    return (
        <AvatarGroup max={2}>
            {
                requestProduct.map((item, index) => (
                    <Avatar key={index} alt={`${item.name}`} src={item.url} />
                ))
            }
        </AvatarGroup>
    );
}
